import React from 'react';
import parse from "html-react-parser";
import * as utility from "../../utilities/utils";
import cardBiltImage from "../../global/img/wf/eca-bilt-conversion.svg";


function  BiltConversionLandingComponent(props)  {
utility.getTitleConfirmcard();
let params = utility.getParams();
let utilityLabel1 ='';
  if(params.language === "es"){
     utilityLabel1 = require("../resources/resources.es");
  }else{
    utilityLabel1 = require("../resources/resources.en");
  }
return (
  <main className="main-wrapper flex-shrink-0 subtitle-0" id="biltConfirmPage">
      <div className="container my-3" >
        <div className="row pagetitle-container">
          <div className="col-12 text-center pb-5 pb-md-4">
                  <img
                    id="imgBiltCard"
                src={cardBiltImage}
                alt=""
                className="img-fluid d-none d-sm-inline"
                style={{ width: "100%", maxWidth: "327px" }}
                  />
              <img
                id="imgCardBilt"
                src={cardBiltImage}
                alt=""
                className="img-fluid d-inline d-sm-none"
                style={{ width: "100%", maxWidth: "184px" }}
              />
            <h1 className="eca-confirm-title text-center text-400 pb-2 pt-md-3" id="eca-confirm-title" style={{ fontSize:"40px" }}>
            {parse(utilityLabel1.utilityLabel.lblBiltLandingMsg1)}
            </h1>
            <p className="eca-confirm-body text-center">{parse(utilityLabel1.utilityLabel.lblBiltLandingMsg2)}</p>
          <div className="mt-5">
            <a
              href="https://sites.wf.com/-staging/bilt-conversion-faq/"
              className="eca-faq-link"
              id="faqRedirectLink"
              tabIndex="0"
              style={{ textDecoration: "none" }}
            >
              <strong>{parse(utilityLabel1.utilityLabel.lblBiltLandingMsg3)} &gt;</strong>
            </a>
          </div>
          </div>
        </div>
      </div>
      </main>
    );
}


export default BiltConversionLandingComponent;
